"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkspaceList = void 0;
const app_1 = require("@koopajs/app");
const react_redux_1 = require("react-redux");
const useWorkspaceList = () => {
    const dispatchSwitchWorkspace = app_1.Operations.Workspaces.switchActive(react_redux_1.useDispatch());
    const dispatchCreateWorkspace = app_1.Operations.Workspaces.create(react_redux_1.useDispatch());
    const setActiveWorkspace = async (workspaceId) => {
        return await dispatchSwitchWorkspace(workspaceId);
    };
    const createWorkspace = async (name) => {
        return await dispatchCreateWorkspace(name);
    };
    const workspaces = react_redux_1.useSelector(app_1.Selectors.Workspaces.getAll);
    const activeWorkspaceId = react_redux_1.useSelector(app_1.Selectors.Workspaces.getActiveWorkspaceId);
    const { errorMessage, isProcessing } = react_redux_1.useSelector(app_1.Selectors.Workspaces.state);
    return {
        workspaces,
        activeWorkspaceId,
        errorMessage,
        isProcessing,
        createWorkspace,
        setActiveWorkspace
    };
};
exports.useWorkspaceList = useWorkspaceList;
//# sourceMappingURL=useWorkspaceList.js.map